export let parcelModules = []

export function registerAngularModule(name) {
    parcelModules.push(name)
}

vrequirejs2_angular_modules.push('vparcel.root')